export default {
  data() {
    return { windowheight: 0, viewportTop: 0, scrollAffix: false, historyAnchor: null, viewportFrame: null };
  },
  methods: {
    scrollContainer() {
      const scrollbar = this.$refs.scrollbarRef;
      return scrollbar && scrollbar.$el.querySelector('.el-scrollbar__wrap');
    },
    chatwindowscrollevent() {
      const container = this.scrollContainer();
      if (container) this.scrollAffix = container.scrollHeight - container.scrollTop - container.clientHeight > 50;
    },
    scrollToBottomImmediate() {
      this.$nextTick(() => requestAnimationFrame(() => {
        const container = this.scrollContainer();
        if (container) container.scrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
      }));
    },
    handleImageLoad() { if (!this.scrollAffix) this.scrollToBottomImmediate(); },
    handleViewportResize() {
      const viewport = window.visualViewport;
      this.windowheight = viewport ? viewport.height : document.documentElement.clientHeight;
      this.viewportTop = viewport ? viewport.offsetTop : 0;
      this.handleImageLoad();
    },
    captureHistoryPosition() {
      const container = this.scrollContainer();
      if (container) this.historyAnchor = { top: container.scrollTop, height: container.scrollHeight };
    },
  },
  watch: {
    messages: {
      handler(messages, previous = []) {
        const container = this.scrollContainer();
        if (this.historyAnchor && previous.length && messages.length && Number(messages[0].id) < Number(previous[0].id)) {
          const anchor = container ? { top: container.scrollTop, height: container.scrollHeight } : this.historyAnchor;
          this.historyAnchor = null;
          this.$nextTick(() => { if (container) container.scrollTop = anchor.top + container.scrollHeight - anchor.height; });
          return;
        }
        const keys = new Set(previous.map(message => message.client_msg_id || message.id));
        const outgoing = messages.some(message => message.sender_id == this.$store.state.User.id &&
          !keys.has(message.client_msg_id || message.id));
        if (outgoing) this.scrollAffix = false;
        if (!this.scrollAffix) this.scrollToBottomImmediate();
      },
    },
    'curItem.uid'() { this.scrollAffix = false; this.historyAnchor = null; this.scrollToBottomImmediate(); },
  },
  mounted() {
    this.handleViewportResize();
    window.addEventListener('resize', this.handleViewportResize);
    window.addEventListener('orientationchange', this.handleViewportResize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.handleViewportResize);
      window.visualViewport.addEventListener('scroll', this.handleViewportResize);
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleViewportResize);
    window.removeEventListener('orientationchange', this.handleViewportResize);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.handleViewportResize);
      window.visualViewport.removeEventListener('scroll', this.handleViewportResize);
    }
  },
};
